import axios from "axios";

export const SUBJECT_OUTCOME_URL = "/SubjectOutcome";

/** Belli Bir Konu Kazanımı Listesini Elde Eder */
export function getSubjectOutcomes(queryParams) {
  return axios.post(`${SUBJECT_OUTCOME_URL}/GetSubjectOutcomes`, queryParams);
}

/** Belli Bir Konu Kazanımı Listesini Sayfalama Olmadan Elde Eder */
export function getAllSubjectOutcomes(queryParams) {
  return axios.post(`${SUBJECT_OUTCOME_URL}/GetAllSubjectOutcomes`, queryParams);
}

/** Yeni Bir Konu Kazanımı Elde Eder */
export function getNewSubjectOutcome(subjectId) {
  return axios.get(`${SUBJECT_OUTCOME_URL}/GetNewSubjectOutcome/${subjectId}`);
}

/** Belli Bir Konu Kazanımını Elde Eder */
export function getSubjectOutcome(id) {
  return axios.get(`${SUBJECT_OUTCOME_URL}/${id}`);
}

/** Belli Bir Konu Kazanımını Kaydeder */
export function saveSubjectOutcome(outcome) {
  return axios.post(SUBJECT_OUTCOME_URL, outcome);
}

/** Belli Bir Konu Kazanımı Listesini Siler */
export function deleteSubjectOutcomes(ids) {
  return axios.post(`${SUBJECT_OUTCOME_URL}/Delete`, ids);
}